import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';

const customApp: App = {
  appId: 'custom',
};class SSAUBaseLoader {
    lmsBaseUrl = '';
    ssauStaticUrl = '';

    constructor({ config }) {
        this.lmsBaseUrl = config.LMS_BASE_URL;
        if (this.lmsBaseUrl) {
            this.ssauStaticUrl = new URL('/static/ssau/', this.lmsBaseUrl).href;
        }
    }

    injectStyles(relativePath) {
        if (!this.ssauStaticUrl) {
            console.warn(`[${this.constructor.name}] Delaying asset loading: LMS_BASE_URL is unassigned.`);
            return;
        }
        const href = new URL(relativePath, this.ssauStaticUrl).href;
        if (!document.querySelector(`link[href="${href}"]`)) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            document.head.appendChild(link);
        }
    }

    injectScript(relativePath, options = { async: false, defer: true }) {
        if (!this.ssauStaticUrl) {
            console.warn(`[${this.constructor.name}] Delaying asset loading: LMS_BASE_URL is unassigned.`);
            return;
        }
        const href = new URL(relativePath, this.ssauStaticUrl).href;
        if (!document.querySelector(`script[src="${href}"]`)) {
            const script = document.createElement('script');
            script.src = href;
            script.async = options.async;
            script.defer = options.defer;
            document.head.appendChild(script);
        }
    }
}

class SSAUAllLoader extends SSAUBaseLoader {
    loadScript() {
        this.injectStyles('css/cookieconsent.css');
        this.injectStyles('css/footer.css');

        this.injectScript('js/counters.js');
        this.injectScript('js/cookieconsent.js');
        this.injectScript('js/cookieconsent-config.js');
        this.injectScript('js/footer.js');

        if (!document.querySelector('meta[name="yandex-verification"]')) {
            const meta = document.createElement('meta');
            meta.name = "yandex-verification";
            meta.content = "cc1984c1c44fadd6";
            document.head.appendChild(meta);
        }
    }
}

class SSAUCatalogLoader extends SSAUBaseLoader {
    loadScript() {
        this.injectStyles('css/details.css');
    }
}
addScript(customApp, SSAUAllLoader);

export default customApp;